import React from 'react'
import { ApiErrorModal, Helper, Loader, NoInformationFound, Pagination, TemplateTable } from 'Components';
import SplitReportTableTemplate from './SplitReportTableTemplate';
import i18n from 'src/i18n';
import { Fetch } from 'helpers/index';

const SplitReportPage = (props) => {
  //#region : Variables Section:
  //! Variables and Props:
  const {
    data = [],
    appState,
    setAppState,
    pageSize,
    menuRow = null,
    isLoading,
    totalItems,
    sort = 'Status',
    code = 'splitReport',
    viewCode = 'splitReport',
    pageNumber,
    setData,
    handleTrExpand,
    handleMoreVertClick,
    handleMenuClick,
    isRowLoading,
    handlePageNumberChange,
    fetchSplitReportsRequests,
    tempUpdateSplitReportRequestData,
    handleSortClick,
  } = props;


  // ! Other Variables:
  const { splitReport = {} } = appState;
  const { keys = [], keyPairs = {} } = splitReport;

  //#endregion : Variables Section.



  return (
    <div className="invoices-list">
      {/*  ! The Split Report table: */}
      <div className="invoices-list__content__table">


        {/* ! loading component */}
        {isLoading && <Loader isSolidWhite />}

        {
          // ! No Data to display message:
          !isLoading && !data.length ? (
            <NoInformationFound
              titleText={i18n.t('splitReports:NoSplitReportRequestsToShow')}
            />
          )
            // ! Split Report table template component:
            : (data.length > 0 &&
              <TemplateTable
                //! ORIGINAL:
                data={data}
                setData={setData}
                keys={keys}
                keyPairs={keyPairs}
                sort={sort}
                code={code}

                // ! Sub Split Reports Table Template.
                template={SplitReportTableTemplate}
                className="template-table__invoices"
                showLoader={isLoading}
                onTrExpand={handleTrExpand}

                menuRow={menuRow}
                onMoreVertClick={handleMoreVertClick}
                onMenuClick={handleMenuClick}
                viewCode={viewCode}
                isDraggable
                onSettingClick={() => setAppState({
                  settingTableCode: viewCode,
                })}
                leadingColumnCount={1}
                trailingColumnCount={0}
                hasSettings

                setAppState={setAppState}
                splitReportTabPageSize={pageSize}
                isLoading={isLoading}
                isRowLoading={isRowLoading}
                totalItems={totalItems}
                currentPage={pageNumber}

                handleSortClick={handleSortClick}
                hasManualSort

                {...props}
              />)
        }
        {/* ! End of Invoices Table */}
      </div>



      {/* ! Pagination component: */}

      {!isLoading && data && data.length > 0 && <div className="invoices-list__content__pagination">
        <Helper text={i18n.t('tutorials:pagination.1')}>
          <Pagination
            onClick={handlePageNumberChange}
            currentPage={pageNumber}
            itemsPerPage={pageSize}
            totalItems={totalItems}
          />
        </Helper>
      </div>}
    </div>
  );
}

export default SplitReportPage





// WEBPACK FOOTER //
// ./src/containers/Jobs/SplitReportTab/SplitReportPage.jsx